import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import '../css/App.output.css';
import client from '../wf/client';
import { gql, useReactiveVar, ApolloProvider } from '@apollo/client';
import { SubscriptionBenefit } from "@withfriendsco/wf-components";
import SaveSubscriptionBenefit from "./SaveSubscriptionBenefit";
import { currentShopifyVersionVar, currentBusinessIdVar, TimeoutScreen, currentShopifyProductVariantsVar, currentBusinessHasTooManyProductsVar, tooManyProductsThreshold } from '@withfriendsco/wf-components';
import { BrowserRouter as Router } from "react-router-dom";
import { useGetProductVariantsQuery } from "../types";
import { MixpanelProvider, useMixpanel } from 'react-mixpanel-browser';
import { Provider as RollbarProvider, ErrorBoundary as RollbarErrorBoundary } from '@rollbar/react';
gql `
query GetProductVariants($id: ID!) {
  business(id: $id) {
    id
    shopifyProductsCount
    shopifyProductVariants{
      id
      displayName
      price
      inventory
      inventoryTracked
      productId
      productType
      vendor
      tags
      createdAt
      collections
      productTitle
      variantTitle
      description
      imageUrl
      onlineStoreUrl
      sku
    }
  }
}
`;
const SubscriptionApp = ({ id, businessId, shopifyVersion, welcomeGiftMembershipId, driveGiftId }) => {
    currentShopifyVersionVar(shopifyVersion);
    currentBusinessIdVar(businessId);
    const rollbarConfig = {
        accessToken: '91124c51aa0c42968e3378eee144e8df',
        captureUncaught: true,
        captureUnhandledRejections: true,
        environment: process.env.NODE_ENV === "development" ? "development" : "production",
    };
    return (_jsx(RollbarProvider, { config: rollbarConfig, children: _jsx(RollbarErrorBoundary, { fallbackUI: () => _jsx("div", { children: "Something went wrong, and our team has been alerted. Try refreshing, or reach out to support@withfriends.co for help" }), children: _jsx(ApolloProvider, { client: client, children: _jsx(SubscriptionAppInner, { businessId: businessId, id: id, shopifyVersion: shopifyVersion, welcomeGiftMembershipId: welcomeGiftMembershipId, driveGiftId: driveGiftId }) }) }) }));
};
const SubscriptionAppInner = ({ id, businessId, shopifyVersion, welcomeGiftMembershipId, driveGiftId }) => {
    var _a, _b;
    const mixpanel = useMixpanel();
    useEffect(() => {
        if (!mixpanel)
            return;
        // Tracks users who come to this site when they already have a cookie set on withfriends.co
        if (mixpanel.get_distinct_id().indexOf("@") === -1) {
            document.cookie = `wf-lm-id=${mixpanel.get_distinct_id()};domain=.withfriends.co;secure;path=/`;
        }
    }, [mixpanel]);
    const currentBusinessHasTooManyProducts = useReactiveVar(currentBusinessHasTooManyProductsVar);
    const { data: dataProducts, error: errorProducts, stopPolling: stopPollingProducts } = useGetProductVariantsQuery({
        variables: {
            id: businessId,
        },
        pollInterval: 1000,
        skip: !businessId || shopifyVersion != 2 || currentBusinessHasTooManyProducts,
    });
    useEffect(() => {
        var _a;
        if (((_a = dataProducts === null || dataProducts === void 0 ? void 0 : dataProducts.business) === null || _a === void 0 ? void 0 : _a.shopifyProductsCount) > tooManyProductsThreshold) {
            currentBusinessHasTooManyProductsVar(true);
            stopPollingProducts();
        }
    }, [(_a = dataProducts === null || dataProducts === void 0 ? void 0 : dataProducts.business) === null || _a === void 0 ? void 0 : _a.shopifyProductsCount]);
    useEffect(() => {
        var _a;
        if (((_a = dataProducts === null || dataProducts === void 0 ? void 0 : dataProducts.business) === null || _a === void 0 ? void 0 : _a.shopifyProductVariants) != null) {
            stopPollingProducts();
            currentShopifyProductVariantsVar(dataProducts.business.shopifyProductVariants);
        }
    }, [(_b = dataProducts === null || dataProducts === void 0 ? void 0 : dataProducts.business) === null || _b === void 0 ? void 0 : _b.shopifyProductVariants]);
    return (_jsx(MixpanelProvider, { token: process.env.REACT_APP_MIXPANEL_KEY, children: _jsx(Router, { children: _jsx("div", { id: "tw-root", children: _jsxs("div", { id: "tw-main", className: "App container text-center", children: [_jsxs("div", { className: "flex flex-wrap justify-center font-sans", children: [_jsx(SubscriptionBenefit, { id: id, fromOnboarding: false, welcomeGiftMembershipId: welcomeGiftMembershipId, driveGiftId: driveGiftId }), _jsx("div", { className: "w-full" }), _jsx(SaveSubscriptionBenefit, { id: id, isWelcomeGift: !!welcomeGiftMembershipId, isDriveGift: !!driveGiftId })] }), _jsx(TimeoutScreen, {})] }) }) }) }));
};
export default SubscriptionApp;
